import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ScrollToTop from '@/components/ScrollToTop';

import Home from '@/pages/Home';
import About from '@/pages/About';
import GroupCompanies from '@/pages/GroupCompanies';
import Industries from '@/pages/Industries';
import Projects from '@/pages/Projects';
import GlobalPresence from '@/pages/GlobalPresence';
import Careers from '@/pages/Careers';
import Contact from '@/pages/Contact';
import SeoPage from '@/pages/SeoPage';

import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import { AuthProvider } from '@/auth/AuthContext';
import ProtectedRoute from '@/auth/ProtectedRoute';

function Shell({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  return (
    <>
      {!isAdmin && <Navbar />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Shell>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/group-companies" element={<GroupCompanies />} />
              <Route path="/industries-served" element={<Industries />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/global-presence" element={<GlobalPresence />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact" element={<Contact />} />
              {/* SEO landing pages */}
              <Route path="/industrial-epc" element={<SeoPage />} />
              <Route path="/process-piping" element={<SeoPage />} />
              <Route path="/textile-engineering" element={<SeoPage />} />
              <Route path="/infrastructure" element={<SeoPage />} />
              <Route path="/welding-automation" element={<SeoPage />} />
              <Route path="/software-development" element={<SeoPage />} />
              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Home />} />
            </Routes>
          </Shell>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
